import "../style/ApiTestingCheat.css";
import { NavLink } from "react-router-dom";
import ArticleSidebar from "../components/ArticleSidebar";

const ApiTestingCheatSheet = () => {
  return (
    <div className="api-cheat-sheet">

  {/* SIDEBAR */}
      <ArticleSidebar />

  <main className="main-content-area">
        <h1 className="entry-title">API Testing – Complete Cheat Sheet (QA / Automation Friendly)</h1>

        <div className="post-content">

      {/* 1 */}
      <section>
        <h2>1. What is an API?</h2>
        <p>
          <strong>API (Application Programming Interface)</strong> allows two
          systems to communicate using requests and responses over HTTP/HTTPS.
        </p>

        <h4>Common API Types</h4>
        <ul>
          <li>REST</li>
          <li>SOAP</li>
          <li>GraphQL</li>
          <li>gRPC</li>
        </ul>
      </section>

      {/* 2 */}
      <section>
        <h2>2. API Architecture Overview</h2>

        <h4>Core Components</h4>
        <ul>
          <li><strong>Client:</strong> Postman, Browser, Mobile App</li>
          <li><strong>Request:</strong> URL + Method + Headers + Body</li>
          <li><strong>Server:</strong> Backend Service</li>
          <li><strong>Response:</strong> Status Code + Headers + Body</li>
        </ul>
      </section>

      {/* 3 */}
      <section>
        <h2>3. URL Structure</h2>

        <pre>
          <code>
            https://api.shipx.com/v1/consignments?status=active&limit=10
          </code>
        </pre>

        <table>
          <thead>
            <tr>
              <th>Part</th>
              <th>Description</th>
              <th>Example</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Protocol</td>
              <td>Communication Type</td>
              <td>https</td>
            </tr>
            <tr>
              <td>Base URL</td>
              <td>Server Address</td>
              <td>api.shipx.com</td>
            </tr>
            <tr>
              <td>Path URL</td>
              <td>Resource Path</td>
              <td>/v1/consignments</td>
            </tr>
            <tr>
              <td>Query Params</td>
              <td>Filters</td>
              <td>status=active</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* 4 */}
      <section>
        <h2>4. HTTP Methods (CRUD)</h2>
        <table>
          <thead>
            <tr>
              <th>Method</th>
              <th>Use Case</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>GET</td><td>Read</td><td>Fetch Data</td></tr>
            <tr><td>POST</td><td>Create</td><td>Create Resource</td></tr>
            <tr><td>PUT</td><td>Update</td><td>Full Update</td></tr>
            <tr><td>PATCH</td><td>Update</td><td>Partial Update</td></tr>
            <tr><td>DELETE</td><td>Delete</td><td>Remove Resource</td></tr>
          </tbody>
        </table>
      </section>

      {/* 5 */}
      <section>
        <h2>5. Headers</h2>

        <h4>Common Request Headers</h4>
        <ul>
          <li>Content-Type: application/json</li>
          <li>Authorization: Token / Bearer</li>
          <li>Accept</li>
          <li>User-Agent</li>
        </ul>

        <h4>Common Response Headers</h4>
        <ul>
          <li>Date</li>
          <li>Server</li>
          <li>Cache-Control</li>
        </ul>
      </section>

      {/* 6 */}
      <section>
        <h2>6. Authentication & Authorization</h2>

        <h4>Basic Auth</h4>
        <pre>
          <code>Authorization: Basic base64(username:password)</code>
        </pre>

        <h4>Bearer Token</h4>
        <pre>
          <code>Authorization: Bearer eyJhbGciOiJIUzI1NiIs...</code>
        </pre>

        <h4>OAuth 2.0 Flow</h4>
        <ol>
          <li>Login → Get Access Token</li>
          <li>Use token in header</li>
          <li>Refresh token on expiry</li>
        </ol>
      </section>

      {/* 7 */}
      <section>
        <h2>7. Request Body / Payload</h2>

        <pre>
          <code>
{`{
  "consignmentId": "CN123",
  "weight": 12.5,
  "mode": "AIR"
}`}
          </code>
        </pre>

        <h4>Payload Types</h4>
        <ul>
          <li>JSON</li>
          <li>XML</li>
          <li>Form-data</li>
          <li>x-www-form-urlencoded</li>
        </ul>
      </section>

      {/* 8 */}
      <section>
        <h2>8. Query Parameters</h2>
        <pre>
          <code>GET /orders?fromDate=2025-01-01&toDate=2025-01-31</code>
        </pre>
      </section>

      {/* 9 */}
      <section>
        <h2>9. Path Parameters</h2>
        <pre>
          <code>GET /orders/{"{orderId}"}</code>
        </pre>
      </section>

      {/* 10 */}
      <section>
        <h2>10. API Response</h2>

        <table>
          <thead>
            <tr>
              <th>Code</th>
              <th>Meaning</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>200</td><td>Success</td></tr>
            <tr><td>201</td><td>Created</td></tr>
            <tr><td>400</td><td>Bad Request</td></tr>
            <tr><td>401</td><td>Unauthorized</td></tr>
            <tr><td>403</td><td>Forbidden</td></tr>
            <tr><td>404</td><td>Not Found</td></tr>
            <tr><td>429</td><td>Rate Limit</td></tr>
            <tr><td>500</td><td>Server Error</td></tr>
          </tbody>
        </table>
      </section>

      {/* 11 */}
      <section>
        <h2>11. Response Validation</h2>
        <ul>
          <li>Mandatory fields</li>
          <li>Data type</li>
          <li>Value correctness</li>
          <li>Schema validation</li>
        </ul>
      </section>

      {/* 12 */}
      <section>
        <h2>12. API Variables (Postman)</h2>
        <pre>
          <code>
            {`{{baseUrl}}
{{accessToken}}`}
          </code>
        </pre>
      </section>

      {/* 13 */}
      <section>
        <h2>13. Collections</h2>
        <ul>
          <li>Folder</li>
          <li>Requests</li>
          <li>Pre-request Scripts</li>
          <li>Tests</li>
        </ul>
      </section>

      {/* 14 */}
      <section>
        <h2>14. Pre-request Script</h2>
        <pre>
          <code>pm.environment.set("timestamp", Date.now());</code>
        </pre>
      </section>

      {/* 15 */}
      <section>
        <h2>15. Test Script Example</h2>
        <pre>
          <code>
{`pm.test("Status 200", () => {
  pm.response.to.have.status(200);
});`}
          </code>
        </pre>
      </section>

      {/* 16 */}
      <section>
        <h2>16. Security & Best Practices</h2>
        <ul>
          <li>Authentication & Authorization</li>
          <li>Token expiry</li>
          <li>HTTPS enforcement</li>
          <li>Automate Smoke APIs</li>
          <li>Validate DB vs API</li>
        </ul>
      </section>

      <blockquote>
        If API returns 200 but business logic fails → still a bug.
      </blockquote>

     
        <footer className="fusion-meta-info">
          <div className="fusion-meta-info-wrapper">
            By{" "}
            <span className="vcard">
              <NavLink to="#author"> Manish Kumar </NavLink>
            </span>
            <span className="black-white-box-fusion-inline-sep"> |</span>
            <span> June 17th, 2025 </span>
            <span className="fusion-inline-sep">|</span>
            <NavLink className="black-white-box" to="/software-testing">
              Software Testing
            </NavLink>
          </div>
        </footer>

        <div className="sharing-box">
          <h4>Share This Story, Choose Your Platform!</h4>
          <div className="fusion-social-networks">
            <NavLink to="#" className="facebook">
              <i className="fab fa-facebook-f"></i>
            </NavLink>
            <NavLink to="#" className="twitter">
              <i className="fab fa-twitter"></i>
            </NavLink>
            <NavLink to="https://www.linkedin.com/in/qa-coder-708418404/" target="_blank" rel="noreferrer" className="linkedin">
              <i className="fab fa-linkedin-in"></i>
            </NavLink>
            <NavLink to="https://wa.me/918299775823" target="_blank" rel="noreferrer" className="whatsapp">
              <i className="fab fa-whatsapp"></i>
            </NavLink>
            <NavLink to="#" className="email">
              <i className="fas fa-envelope"></i>
            </NavLink>
            <NavLink to="https://www.instagram.com/qacoder0/?hl=en" target="_blank" rel="noreferrer" className="instagram">
              <i className="fab fa-instagram"></i>
            </NavLink>
          </div>
        </div>
   

</div>
    </main>

     </div>
  );
};

export default ApiTestingCheatSheet;

